import { useFieldContext } from "..";
import { Textarea } from "../../ui/textarea";
import { getErrorMessage } from "../utils";
import FieldWrapper from "./FieldWrapper";

type TextAreaFieldProps = {
  label?: string;
  subLabel?: string;
  wrapperClassName?: string;
  childrenContainerClassName?: string;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  labelRight?: React.ReactNode;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextAreaField = ({
  label,
  subLabel,
  required,
  wrapperClassName,
  childrenContainerClassName,
  inputRef,
  labelRight,
  ...textAreaProps
}: TextAreaFieldProps) => {
  const field = useFieldContext<string>();

  const hasError = field.state.meta.errors.length > 0 && field.state.meta.isDirty;

  const errors = field.state.meta.errors;

  return (
    <FieldWrapper
      id={field.name}
      label={label}
      subLabel={subLabel}
      isRequired={required}
      errorMessage={hasError ? getErrorMessage(errors[0]) : undefined}
      className={wrapperClassName}
      childrenContainerClassName={childrenContainerClassName}
      labelRight={labelRight}
    >
      <Textarea
        id={field.name}
        value={field?.state?.value}
        aria-invalid={hasError}
        onBlur={field.handleBlur}
        onChange={(e) => field.handleChange(e.target.value)}
        ref={inputRef}
        {...textAreaProps}
      />
    </FieldWrapper>
  );
};
